<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'">
   <div mat-dialog-title class="dialog-header">
      <h3 class="dialog-title">{{ title }}</h3>
      <button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"><mat-icon>close</mat-icon></button>
   </div>
   <form [formGroup]="form" class="inboundCallRuleForm" (ngSubmit)="onCreate()">
      <mat-dialog-content>
         <mat-form-field>
            <mat-label>Description</mat-label>
            <input matInput autocomplete="off" formControlName="comment" [name]="'comment'" />
         </mat-form-field>
         <mat-slide-toggle color="primary" (change)="onDateToggleClick($event)" [checked]="dateToggleChecked"
            >Specific Dates</mat-slide-toggle
         >
         <mat-form-field class="date-range">
            <mat-label>Date Range</mat-label>
            <mat-date-range-input [rangePicker]="picker" [disabled]="!dateToggleChecked">
               <input
                  matStartDate
                  placeholder="Start date"
                  formControlName="startDate"
                  [required]="dateToggleChecked"
                  [name]="'startDate'"
               />
               <input
                  matEndDate
                  placeholder="End date"
                  formControlName="endDate"
                  [required]="dateToggleChecked"
                  [name]="'endDate'"
               />
            </mat-date-range-input>
            <mat-hint>MM/DD/YYYY – MM/DD/YYYY</mat-hint>
            <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
            <mat-date-range-picker #picker></mat-date-range-picker>
            @if (form.controls.startDate.hasError('matStartDateInvalid')) {
            <mat-error>Invalid start date</mat-error>
            } @if (form.controls.endDate.hasError('matEndDateInvalid')) {
            <mat-error>Invalid end date</mat-error>
            } @if (form.get('startDate')?.hasError('required')) {
            <mat-error> Start Date is Required. </mat-error>
            } @if (form.get('endDate')?.hasError('required')) {
            <mat-error> End Date is Required. </mat-error>
            }
         </mat-form-field>
         <mat-slide-toggle
            class="specific-time-toggle"
            color="primary"
            (change)="onTimeToggleClick($event)"
            [checked]="timeToggleChecked"
            >Specific Time</mat-slide-toggle
         >
         <div class="detail-right-column">
            @if (isSafari()) {
            <div class="segmented-timepicker-wrapper flex-half">
               <ndt-segmented-timepicker
                  [required]="timeToggleChecked"
                  label="Start Time"
                  formControlName="startTime"
               ></ndt-segmented-timepicker>
               @if (form.get('startTime')?.touched && form.get('startTime')?.invalid) {
               <div class="segmented-timepicker-error">
                  @if (form.get('startTime')?.hasError('required')) {
                  <span>Start Time is required.</span>
                  } @if (form.get('startTime')?.hasError('invalidTimeRange')) {
                  <span>Start Time should be before End Time.</span>
                  }
               </div>
               }
            </div>
            <div class="segmented-timepicker-wrapper flex-half">
               <ndt-segmented-timepicker
                  [required]="timeToggleChecked"
                  label="End Time"
                  formControlName="endTime"
               ></ndt-segmented-timepicker>
               @if (form.get('endTime')?.touched && form.get('endTime')?.invalid) {
               <div class="segmented-timepicker-error">
                  @if (form.get('endTime')?.hasError('required')) {
                  <span>End Time is required.</span>
                  } @if (form.get('endTime')?.hasError('invalidTimeRange')) {
                  <span>End Time should be after Start Time.</span>
                  }
               </div>
               }
            </div>
            } @else {
            <mat-form-field class="flex-half field-padding-right">
               <mat-label>Start Time</mat-label>
               <input
                  matInput
                  type="time"
                  autocomplete="off"
                  formControlName="startTime"
                  [required]="timeToggleChecked"
                  [name]="'startTime'"
               />
               @if (form.get('startTime')?.hasError('required')) {
               <mat-error> Start Time is Required. </mat-error>
               } @if (form.get('startTime')?.hasError('invalidTimeRange')) {
               <mat-error>Start Time should be before End Time.</mat-error>
               }
            </mat-form-field>
            <mat-form-field class="flex-half">
               <mat-label>End Time</mat-label>
               <input
                  matInput
                  type="time"
                  autocomplete="off"
                  formControlName="endTime"
                  [required]="timeToggleChecked"
                  [name]="'endTime'"
               />
               @if (form.get('endTime')?.hasError('required')) {
               <mat-error> End Time is Required. </mat-error>
               } @if (form.get('endTime')?.hasError('invalidTimeRange')) {
               <mat-error>End Time should be after Start Time.</mat-error>
               }
            </mat-form-field>
            }
         </div>
         <mat-checkbox class="select-all" formControlName="selectAll">Select All</mat-checkbox>
         <br />
         <div formGroupName="daysOfWeekGroup" class="days-of-week-group">
            @for (key of daysMap.keys(); track key) {
            <mat-checkbox class="checkbox-margin" [formControlName]="key" [name]="key">
               {{ daysMap.get(key) }}
            </mat-checkbox>
            }
            <div class="days-of-week-errors">
               @if (form.get('daysOfWeekGroup')?.hasError('atLeastOneCheckboxRequired')) {
               <mat-error>At least one Day required</mat-error>
               }
            </div>
         </div>
         <mat-form-field>
            <mat-label>Route Extension*</mat-label>
            <input
               matInput
               autocomplete="off"
               type="text"
               formControlName="routeExtension"
               [name]="'routeExtension'"
               ndtExtensionSelect
               [lcsSingleSelect]="extensionSelect"
               [accountId]="extension?.accountId"
               [extensionTypesToExclude]="[7]"
               [placeholder]="routeExtensionPlaceholder"
            />
            <ndt-extension-select
               #extensionSelect
               [nullActionsToInclude]="availableNullActions"
               (optionsLoaded)="onExtensionOptionsLoaded($event)"
               [excludedIds]="[extension?.extensionId]"
            ></ndt-extension-select>
         </mat-form-field>
      </mat-dialog-content>
      <mat-dialog-actions>
         <button type="submit" title="Create" mat-raised-button>Save</button>
      </mat-dialog-actions>
   </form>
</lcs-loading-overlay>
